module.exports = __webpack_public_path__ + "static/media/Base feature icon-4.ba3f2b45.svg";